import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CommentConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CustomerCommentService } from './api/customerComment.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CommentApiModule {
    public static forRoot(configurationFactory: () => CommentConfiguration): ModuleWithProviders<CommentApiModule> {
        return {
            ngModule: CommentApiModule,
            providers: [ { provide: CommentConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CommentApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CommentApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
